"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Buttons = require("./Buttons");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    codeBlock: {
      width: '100%',
      whiteSpace: 'pre-wrap',
      borderRadius: '5px',
      padding: spacing(2),
      backgroundColor: palette.secondary.light,
      color: palette.error.dark,
      fontFamily: 'monospace',
      fontSize: '0.75rem'
    }
  };
});

var AlyceCodeBlock = function AlyceCodeBlock(_ref2) {
  var text = _ref2.text;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.codeBlock
  }, text), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    alignSelf: "flex-start"
  }, /*#__PURE__*/_react["default"].createElement(_Buttons.CopyToClipboardButton, {
    fontSize: 1.25,
    value: text
  })));
};

AlyceCodeBlock.propTypes = {
  text: _propTypes["default"].string.isRequired
};

var _default = /*#__PURE__*/(0, _react.memo)(AlyceCodeBlock);

exports["default"] = _default;